/**
 * @generated SignedSource<<ef4539ca4fea8c2b19ff03b5215f1f8f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type FetchMcpOauthMethodsInput = {
  url: string;
};
export type McpOauthAdvancedSettingsFetchMethodsMutation$variables = {
  input: FetchMcpOauthMethodsInput;
};
export type McpOauthAdvancedSettingsFetchMethodsMutation$data = {
  readonly fetchMcpOauthMethods: {
    readonly error: string | null | undefined;
    readonly methods: ReadonlyArray<string>;
  };
};
export type McpOauthAdvancedSettingsFetchMethodsMutation = {
  response: McpOauthAdvancedSettingsFetchMethodsMutation$data;
  variables: McpOauthAdvancedSettingsFetchMethodsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "FetchMcpOauthMethodsPayload",
    "kind": "LinkedField",
    "name": "fetchMcpOauthMethods",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "methods",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "McpOauthAdvancedSettingsFetchMethodsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "McpOauthAdvancedSettingsFetchMethodsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c0c979622469890499dfda94dc8ba08d",
    "id": null,
    "metadata": {},
    "name": "McpOauthAdvancedSettingsFetchMethodsMutation",
    "operationKind": "mutation",
    "text": "mutation McpOauthAdvancedSettingsFetchMethodsMutation(\n  $input: FetchMcpOauthMethodsInput!\n) {\n  fetchMcpOauthMethods(input: $input) {\n    methods\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "6f0e787917d361c38fe2c05c7dffe505";

export default node;
